// extracted by mini-css-extract-plugin
export default {"wrap":"slideMobile_wrap__C8QaZ","main":"slideMobile_main__Pm8iw","caption":"slideMobile_caption__sipVw","thumbs":"slideMobile_thumbs__M0aA-"};